export type SortDirection = "asc" | "desc";

export const SORT_DIRECTIONS = {
  ASC: "asc" as SortDirection,
  DESC: "desc" as SortDirection,
} as const;
